import { render, staticRenderFns } from "./AttachmentsEdit.vue?vue&type=template&id=789ab7a4"
import script from "./AttachmentsEdit.vue?vue&type=script&lang=js"
export * from "./AttachmentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports